/* B1G2 promo bundle selector.
   Adds the selected units to the cart; the sitewide automatic Buy X Get Y
   discount prices the free items in cart/checkout. */
if (!customElements.get("b1g2-offer")) {
  customElements.define(
    "b1g2-offer",
    class B1g2Offer extends HTMLElement {
      connectedCallback() {
        this.variants = JSON.parse(
          this.querySelector("[data-b1g2-variants]").textContent
        );
        const mapEl = this.querySelector("[data-b1g2-variant-map]");
        this.variantMap = mapEl ? JSON.parse(mapEl.textContent) : null;
        // Metal mix page only: the partner product's map, used by any unit
        // whose Metal select is set to the partner metal.
        const altEl = this.querySelector("[data-b1g2-variant-map-alt]");
        this.altMap = altEl ? JSON.parse(altEl.textContent) : null;
        this.altMetal = altEl ? altEl.dataset.metal : null;
        this.tiers = Array.from(this.querySelectorAll(".b1g2__tier"));
        this.radios = Array.from(this.querySelectorAll(".b1g2__radio"));
        this.button = this.querySelector(".b1g2__atc");
        this.errorEl = this.querySelector(".b1g2__error");

        this.radios.forEach((r) =>
          r.addEventListener("change", () => this.onTierChange())
        );
        this.querySelectorAll(".b1g2__select").forEach((s) => {
          s.addEventListener("change", () => this.hideError());
          this.enhanceSelect(s);
        });
        document.addEventListener("click", (e) => {
          if (!this.contains(e.target)) this.closeSwatchLists();
        });
        // preselect "none" = every tier stays collapsed until the customer picks one
        const pre = this.dataset.preselect || "none";
        const preRadio = this.radios.find((r) => r.value === pre);
        if (preRadio) preRadio.checked = true;
        this.onTierChange();
        this.button.addEventListener("click", (e) => {
          e.preventDefault();
          this.addToCart();
        });
      }

      onTierChange() {
        this.tiers.forEach((t) => {
          const on = t.querySelector(".b1g2__radio").checked;
          t.classList.toggle("is-selected", on);
          const units = t.querySelector(".b1g2__units");
          if (units) units.hidden = !on;
        });
        this.closeSwatchLists();
        this.hideError();
      }

      closeSwatchLists() {
        this.querySelectorAll(".b1g2-swatchdd__list").forEach(
          (l) => (l.hidden = true)
        );
      }

      /* Replace every native <select> with the same custom dropdown. Values that
         resolve via the universal swatch map (birthstone-swatches.js) get their
         image; the rest (e.g. Size) are text only. A native select's popup is
         drawn by the browser outside the page and inside the sticky info column
         it can open detached in a corner (2026-09-28), so none are left native. */
      enhanceSelect(select) {
        const sw = window.ALSwatches;
        /* option name makes the swatch shape-aware (Oval Stone -> pear cut,
           Rectangle Stone -> radiant cut) via ALSwatches.forValue's 2nd arg */
        const optName = select.dataset.optionName || "";
        const swatchFor = (v) => (sw ? sw.forValue(v, optName) : null);
        const opts = Array.from(select.options);
        if (!opts.length) return;

        const wrap = document.createElement("div");
        wrap.className = "b1g2-swatchdd";
        if (select.classList.contains("b1g2__select--metal")) {
          wrap.classList.add("b1g2-swatchdd--metal");
        }
        const btn = document.createElement("button");
        btn.type = "button";
        btn.className = "b1g2-swatchdd__btn";
        btn.setAttribute("aria-haspopup", "listbox");
        btn.setAttribute("aria-label", select.getAttribute("aria-label") || "");
        const list = document.createElement("div");
        list.className = "b1g2-swatchdd__list";
        list.setAttribute("role", "listbox");
        list.hidden = true;

        const render = () => {
          const cur = select.options[select.selectedIndex];
          const url = swatchFor(cur.value);
          btn.innerHTML =
            (url ? '<img src="' + url + '" alt="" loading="lazy">' : "") +
            "<span>" +
            cur.text +
            "</span>" +
            '<svg viewBox="0 0 10 6" aria-hidden="true"><path d="M1 1l4 4 4-4" fill="none" stroke="currentColor" stroke-width="1.5"/></svg>';
          list
            .querySelectorAll(".b1g2-swatchdd__item")
            .forEach((i) =>
              i.classList.toggle("is-current", i.dataset.value === cur.value)
            );
        };

        opts.forEach((o) => {
          const item = document.createElement("button");
          item.type = "button";
          item.className = "b1g2-swatchdd__item";
          item.setAttribute("role", "option");
          item.dataset.value = o.value;
          const url = swatchFor(o.value);
          item.innerHTML =
            (url ? '<img src="' + url + '" alt="" loading="lazy">' : "") +
            "<span>" +
            o.text +
            "</span>";
          item.addEventListener("click", (e) => {
            e.preventDefault();
            e.stopPropagation();
            select.value = o.value;
            select.dispatchEvent(new Event("change", { bubbles: true }));
            render();
            list.hidden = true;
            btn.focus();
          });
          list.appendChild(item);
        });

        btn.addEventListener("click", (e) => {
          e.preventDefault();
          e.stopPropagation();
          const open = list.hidden;
          this.closeSwatchLists();
          list.hidden = !open;
        });
        btn.addEventListener("keydown", (e) => {
          if (e.key === "Escape") list.hidden = true;
        });

        // keep the button honest if anything sets the select's value directly
        select.addEventListener("change", render);
        select.classList.add("is-swatchified");
        select.tabIndex = -1;
        wrap.appendChild(btn);
        wrap.appendChild(list);
        select.insertAdjacentElement("afterend", wrap);
        render();
      }

      activeTier() {
        return this.tiers.find((t) => t.querySelector(".b1g2__radio").checked);
      }

      resolveUnit(unitEl) {
        const sels = Array.from(
          unitEl.querySelectorAll(
            ".b1g2__select:not(.b1g2__select--prop):not(.b1g2__select--metal)"
          )
        );
        if (!sels.length) return this.variants[0];
        const vals = sels.map((s) => s.value);
        const metal = unitEl.querySelector(".b1g2__select--metal");
        if (metal && this.altMap && metal.value === this.altMetal) {
          const altId = this.altMap[vals.join("|")];
          return altId ? { id: altId, available: true } : null;
        }
        if (this.variantMap) {
          // full-catalog map (metafield) — covers products beyond the 250-variant
          // storefront cap; inventoryPolicy CONTINUE, so always purchasable
          const id = this.variantMap[vals.join("|")];
          return id ? { id, available: true } : null;
        }
        return this.variants.find((v) =>
          v.options.every((o, i) => o === vals[i])
        );
      }

      unitProperties(unitEl) {
        const props = {};
        unitEl.querySelectorAll(".b1g2__select--prop").forEach((s) => {
          props[s.dataset.propName] = s.value;
        });
        return Object.keys(props).length ? props : null;
      }

      showError(msg) {
        this.errorEl.textContent = msg;
        this.errorEl.hidden = false;
      }

      hideError() {
        this.errorEl.hidden = true;
      }

      setLoading(on) {
        this.button.classList.toggle("loading", on);
        this.button.disabled = on;
        this.button.setAttribute("aria-busy", on ? "true" : "false");
        // Rendered with `hidden` so it does not sit on the button at rest;
        // the theme's .button.loading rules do the centring and colouring.
        const spinner = this.button.querySelector(".loading__spinner");
        if (spinner) spinner.classList.toggle("hidden", !on);
      }

      async addToCart() {
        const tier = this.activeTier();
        if (!tier) {
          return this.showError("Please select an offer above first.");
        }
        const unitEls = Array.from(tier.querySelectorAll(".b1g2__unit"));
        const unitCount = parseInt(tier.dataset.units, 10) || 1;
        const chosen = unitEls.length
          ? unitEls.map((u) => ({
              variant: this.resolveUnit(u),
              properties: this.unitProperties(u),
            }))
          : Array.from({ length: unitCount }, () => ({
              variant: this.variants[0],
              properties: null,
            }));

        if (chosen.some((c) => !c.variant)) {
          return this.showError(
            "That combination isn't available — please adjust your selections."
          );
        }
        if (chosen.some((c) => !c.variant.available)) {
          return this.showError(
            "One of your selections is sold out — please pick another."
          );
        }

        // one line per unit; the cart merges identical variant+properties lines itself
        const items = chosen.map((c) => {
          const item = { id: c.variant.id, quantity: 1 };
          if (c.properties) item.properties = c.properties;
          return item;
        });

        const cart =
          document.querySelector("cart-notification") ||
          document.querySelector("cart-drawer");
        const body = { items };
        if (cart && cart.getSectionsToRender) {
          body.sections = cart.getSectionsToRender().map((s) => s.id);
          body.sections_url = window.location.pathname;
        }

        this.setLoading(true);
        try {
          const root =
            (window.Shopify && Shopify.routes && Shopify.routes.root) || "/";
          const res = await fetch(root + "cart/add.js", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(body),
          });
          const data = await res.json();
          if (!res.ok || data.status) {
            return this.showError(
              data.description || data.message || "Could not add to cart."
            );
          }
          if (
            typeof publish === "function" &&
            typeof PUB_SUB_EVENTS !== "undefined"
          ) {
            publish(PUB_SUB_EVENTS.cartUpdate, {
              source: "b1g2-offer",
              cartData: data,
            });
          }
          if (cart && cart.renderContents) {
            cart.renderContents(data);
            // first-add render fix: the drawer stays invisible unless is-empty is cleared
            const drawer = document.querySelector("cart-drawer");
            if (drawer) drawer.classList.remove("is-empty");
          } else {
            window.location.href = root + "cart";
          }
        } catch (err) {
          this.showError("Network error — please try again.");
        } finally {
          this.setLoading(false);
        }
      }
    }
  );
}
